import { FolderOpen } from 'lucide-react'

type Props = {
  done: number
  total: number
  onClick: () => void
}

export default function FlowDeliverablesBadge({ done, total, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-600/40 bg-emerald-950/40 px-2.5 py-1 text-xs font-medium text-emerald-200 transition hover:bg-emerald-900/50"
      title="Mes livrables"
    >
      <FolderOpen className="h-3.5 w-3.5" />
      <span className="hidden sm:inline">Mes livrables</span>
      <span className="rounded-full bg-emerald-600 px-1.5 py-0.5 text-[10px] font-bold text-white">
        {done}/{total}
      </span>
    </button>
  )
}
